import React, { useState } from 'react';
import Aside from '../components/Aside';
import Navbar from '../components/Navbar';
import DashboardCards from '../components/DashboardCards';
import { Routes, Route } from 'react-router-dom';
import IndustryListing from './IndustryListing';
import Footer from '../components/Footer';
import Business from './Business';
import User from './User';
import Chat from './Chat/Chat';
import Notification from './Notification';
import Settings from './Settings';
import Faq from './Faq';
import Blog from './Blog';
import NotFound from '../components/NotFound';
import ServicePage from '../components/IndustryManagement/serviceType/ServicePage';
import ReportAnalytics from './ReportAnalytics';
import Receipt from '../components/transcations/Receipt';
import SupportTicket from './support/SupportTicket';
import AllSubscription from '../components/settings/AllSubscription';
import Transaction from './Transaction/Transcation';
import AdminManagement from './AdminManagement';
import SubscriptionPlan from '../components/settings/SubscriptionPlan';
const Dashboard = () => {
  const [searchQuery, setSearchQuery] = useState('');
  return (
    <div className="flex h-screen">
      <Aside />
      <div className="flex flex-col flex-1">
        <Navbar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
        <div className="flex-1 p-2">
          <Routes>
            <Route path="" element={<DashboardCards />} />
            <Route path="/users/*" element={<User searchQuery={searchQuery} />} />
            <Route path="/industry-listing" element={<IndustryListing />} />
            <Route path="/services/:industryId" element={<ServicePage />} />
            <Route path="/services/add" element={<ServicePage />} />
            <Route path="/business/*" element={<Business />} />
            <Route path="/report" element={<ReportAnalytics />} />
            <Route path="/inbox/*" element={<Chat />} />
            <Route path="/notification" element={<Notification />} />
            <Route path="/subscription-plan/*" element={<SubscriptionPlan />} />
            <Route path="/transaction" element={<Transaction />} />
            <Route path="/support" element={<SupportTicket />} />
            <Route path="/subscription" element={<AllSubscription />} />
            <Route path="/receipt" element={<Receipt />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/admin-management/*" element={<AdminManagement />} />
            <Route path="/blog/*" element={<Blog />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Dashboard;
